







































































































































































import Vue from "vue";
import moment from "moment";

// Vue components
import ColoredCurrencyTextField from "@/components/ColoredCurrencyTextField.vue";

// Model
import { formatCurrency } from "@/utility/Formatter";
import { transactionTypeEnumLabel } from "@/model/data/enums/TransactionTypeEnum";
import { TransactionFlowEnum } from "@/model/data/enums/TransactionFlowEnum";
import { InstallationTypeEnum, installationTypeEnumLabel } from "@/model/data/enums/InstallationTypeEnum";
import { Transaction } from "@/model/data/cashFlow/Transaction";
import { mapGetters } from "vuex";

const color0: string = "";
const color1: string = "light-blue lighten-1";
const color2: string = "light-blue lighten-3";

export default Vue.extend({
    components: {
        ColoredCurrencyTextField,
    },
    data() {
        return {
            TransactionFlowEnum,
            InstallationTypeEnum,
            color1,
            color2,
            showTransactionDetails: false,
            fields: [
                { id: "nop", i18n: "common.transactionId" },
                {
                    id: "userName",
                    i18n: "common.username",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "userAlternateId",
                    i18n: "common.username_alternate",
                    condition: (v) => v && v.length > 0,
                },

                {
                    id: "channelId",
                    i18n: "common.channel",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "shiftNumber",
                    i18n: "common.shift_number",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "customerCode",
                    i18n: "common.customer_code",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "bagId",
                    i18n: "common.bag_id",
                    condition: (v) => v && v.length > 0,
                },
            ],
        };
    },
    props: {
        loading: Boolean,
        installationName: String,
        installationType: Number,
        transactions: Array,
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
        greyBackgroundColor() {
            return color0;
        },

        totals() {
            let frontOfficeTransactions = this.transactions.filter((t: Transaction) => t.installationName == this.installationName);
            let backOfficeTransactions = this.transactions.filter((t: Transaction) => t.installationName != this.installationName);

            let frontOfficeCashIn: { key: string; value: number }[] = [];
            let frontOfficeCashOut: { key: string; value: number }[] = [];

            // transazioni di front office in ingresso
            frontOfficeTransactions
                .filter((t: Transaction) => t.flow == TransactionFlowEnum.CashIn)
                .forEach((transaction: Transaction) => {
                    for (let key in transaction.total) {
                        if (frontOfficeCashIn.filter((c) => c.key == transaction.total[key].key).length <= 0) frontOfficeCashIn.push({ key: transaction.total[key].key, value: 0 });
                        frontOfficeCashIn[key].value = frontOfficeCashIn[key].value + transaction.total[key].value;
                    }
                });

            // transazioni di front office in uscita
            frontOfficeTransactions
                .filter((t: Transaction) => t.flow == TransactionFlowEnum.CashOut)
                .forEach((transaction: Transaction) => {
                    for (let key in transaction.total) {
                        if (frontOfficeCashOut.filter((c) => c.key == transaction.total[key].key).length <= 0)
                            frontOfficeCashOut.push({ key: transaction.total[key].key, value: 0 });
                        frontOfficeCashOut[key].value = frontOfficeCashOut[key].value + transaction.total[key].value;
                    }
                });

            let backOfficeCashIn: { key: string; value: number }[] = [];
            let backOfficeCashOut: { key: string; value: number }[] = [];

            // transazioni di back office in ingresso
            backOfficeTransactions
                .filter((t: Transaction) => t.flow == TransactionFlowEnum.CashIn)
                .forEach((transaction: Transaction) => {
                    for (let key in transaction.total) {
                        if (backOfficeCashIn.filter((c) => c.key == transaction.total[key].key).length <= 0) backOfficeCashIn.push({ key: transaction.total[key].key, value: 0 });
                        backOfficeCashIn[key].value = backOfficeCashIn[key].value + transaction.total[key].value;
                    }
                });

            // transazioni di back office in uscita
            backOfficeTransactions
                .filter((t: Transaction) => t.flow == TransactionFlowEnum.CashOut)
                .forEach((transaction: Transaction) => {
                    for (let key in transaction.total) {
                        if (backOfficeCashOut.filter((c) => c.key == transaction.total[key].key).length <= 0) backOfficeCashOut.push({ key: transaction.total[key].key, value: 0 });
                        backOfficeCashOut[key].value = backOfficeCashOut[key].value + transaction.total[key].value;
                    }
                });

            return { frontOfficeCashIn: frontOfficeCashIn, frontOfficeCashOut: frontOfficeCashOut, backOfficeCashIn: backOfficeCashIn, backOfficeCashOut: backOfficeCashOut };
        },

        isFboEqualsToTfo() {
            if (this.totals.frontOfficeCashIn.length != this.totals.backOfficeCashOut.length) return false;
            for (let key in this.totals.frontOfficeCashIn)
                if (this.totals.backOfficeCashOut[key] == null || this.totals.backOfficeCashOut[key].value != this.totals.frontOfficeCashIn[key].value) return false;
            return true;
        },

        isFfoEqualsToTbo() {
            if (this.totals.backOfficeCashIn.length != this.totals.frontOfficeCashOut.length) return false;
            for (let key in this.totals.backOfficeCashIn)
                if (this.totals.frontOfficeCashOut[key] == null || this.totals.frontOfficeCashOut[key].value != this.totals.backOfficeCashIn[key].value) return false;
            return true;
        },
    },
    methods: {
        moment,
        formatCurrency,
        installationTypeEnumLabel,
        transactionTypeEnumLabel,

        getPositionLeft(installation: string) {
            if (this.installationType == InstallationTypeEnum.FrontOffice) return this.installationName == installation;
            else return this.installationName != installation;
        },

        getColor(flow: TransactionFlowEnum, installation: string) {
            if (installation == this.installationName) return flow == TransactionFlowEnum.CashIn ? color1 : color2;
            else return flow == TransactionFlowEnum.CashIn ? color2 : color1;
        },
    },
});
